import { sagaCreator, stateSelector } from 'redux-saga-kit';
import { put, select } from 'redux-saga/effects';
import { addPayment, removePayment, setPayments } from '../engine/actions/CheckoutActions';
import {
  setPaymentAssociations,
  orderItemChangeCount,
  setManagerDiscount,
  changeDeliveryFee,
} from '../engine/actions/OrderActions';
import { derivedPpdData } from '../engine/selectors/derivedPpdData';
import {
  alignIndex,
  alignIndexActions,
  convertCartIndexToFlatIndex,
  removePaymentMethod,
  appendPaymentMethod,
} from '../../utils/PayPerDishUtils';

function* onOrderItemChangeCount({ payload }) {
  const { cartIndex, previousCount, count: currentCount } = payload;
  const ppd = yield select(stateSelector('order.paymentAssociations'));
  const cartOrderItems = yield select(stateSelector('order.previousOrderItems'));
  const flatIndex = convertCartIndexToFlatIndex({ cartOrderItems, index: cartIndex });
  const orderItemIndex = previousCount < currentCount ? flatIndex + 1 : flatIndex;
  const action = previousCount < currentCount ? alignIndexActions.ADD : alignIndexActions.REMOVE;
  const paymentAssociations = alignIndex({ ppd, action, orderItemIndex });
  yield put(setPaymentAssociations({ paymentAssociations }));
}

function* onAddPayment() {
  const ppd = yield select(stateSelector('order.paymentAssociations'));
  const paymentAssociations = appendPaymentMethod({ ppd });
  yield put(setPaymentAssociations({ paymentAssociations }));
}

function* onRemovePayment({ payload }) {
  const { paymentIndex: index } = payload;
  const ppd = yield select(stateSelector('order.paymentAssociations'));
  const paymentAssociations = removePaymentMethod({ ppd, index });
  yield put(setPaymentAssociations({ paymentAssociations }));
}

function* calculateTotalAmounts() {
  const state = yield select();
  const payments = yield select(stateSelector('checkout.payments'));
  const amounts = derivedPpdData(state).map(({ priceComponents }) => {
    return priceComponents.total || 0;
  });
  const paymentsValue = payments.map((payment, index) => {
    return { ...payment, ppdAmount: amounts[index] };
  });
  if (payments.length > 1) {
    // otherwise checkout saga sends this action
    yield put(setPayments({ paymentsValue }));
  }
}

////////////// default export

export default sagaCreator(
  Object.assign({
    [orderItemChangeCount]: { handler: onOrderItemChangeCount, noParams: true },
    [addPayment]: { handler: onAddPayment, noParams: true },
    [removePayment]: { handler: onRemovePayment, noParams: true },
    [setPaymentAssociations]: { handler: calculateTotalAmounts, noParams: true },
    [setManagerDiscount]: { handler: calculateTotalAmounts, noParams: true },
    [changeDeliveryFee]: { handler: calculateTotalAmounts, noParams: true },
  }),
);
